import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const DownloadFailureAlert = ({ handleTemplateDownloadFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleTemplateDownloadFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleTemplateDownloadFailed}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.templateDownloadFailureMessage)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default DownloadFailureAlert;
